import { Platform } from "react-native";
import BarcodeScannerNative from "./BarcodeScannerNative";
import BarcodeScannerWeb from "./BarcodeScannerWeb";

const BarcodeScanner = Platform.OS === "web" ? BarcodeScannerWeb : BarcodeScannerNative;

export default BarcodeScanner;

export { TEXT_STYLES } from "./BarcodeScannerStyles";
